(function() {

  'use strict';

  angular.module('eclipseApp.user').controller('resetPasswordCtrl', ['$scope', '$location', '$modalInstance',
    'uteEndpoint', '$http', '$timeout', '$window', 'janrainService', '$translate', 'util', 'env', 'dtmService', 'dtmServiceConstants', 'uteLocale', 'ute.datalayer.common.service',
    function($scope, $location, $modalInstance, uteEndpoint, $http, $timeout, $window, janrainService,
      $translate, util, env, dtmService, dtmServiceConstants, uteLocale, dataLayerService) {

      var messageHtml = '';
      var dtmServerSideError = 'SS|' + dtmServiceConstants.dtmRules.resetPassword.defaultServerError;
      $scope.loading = true;
      $scope.selectedscreen = '';
      $scope.popupLogin = false;
      $scope.popupLoginErrorType = false;
      $scope.lang = uteLocale.language;

      $scope.emailPwdLinkSend = {
        message: {}
      };

      $scope.pwReset = {};


      $scope.validationUrl = util.getParameterByName('code');

      $scope.emailPwdLinkSendRule = {
        username: {
          required: 'true'
        },
      };

      $scope.blurPassword = function(passwordResetForm) {
        console.info('blur happened');
        if ($scope.pwReset.password || $scope.pwReset.confirmPassword) {
          passwordResetForm.confirmPassword.$setValidity('passwordMismatch', ($scope.pwReset.password === $scope.pwReset.confirmPassword));
        }
        console.info(angular.copy($scope.pwReset), 'pwReset');
        console.info(angular.copy(passwordResetForm), 'passwordResetForm');
      }

      $scope.resetPasswordRule = {
        password: {
          type: 'text',
          minlength: 7,
          maxlength: 16,
          'pattern': '^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!@#$%^&*.:;\'"<>{}\\[\\]]+)$'
        },
        confirmPassword: {
          type: 'text',
          minlength: 7,
          maxlength: 16,
          'pattern': '^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!@#$%^&*.:;\'"<>{}\\[\\]]+)$'
        },

      };

      $scope.popupClosewithMessage = function(message, errorType) {
        /* check if janrain modal is ready then close this one */
        // janrainService.checkJanrainModalReady(function() {
          messageHtml = message;
          $modalInstance.close($scope);
          $scope.popupLogin = true;
          $scope.popupLoginErrorType = errorType;
        // });
      };

      //FUSS-2242 : Show password functionality - start
      $scope.showPass = function() {
        $timeout(function() {
          //Show New password:
          $(".showPasswordButton").hide();
          $(".hidePasswordButton").hide();
          $(".showConfirmPasswordButton").hide();
          $(".hideConfirmPasswordButton").hide();
          $("#password").on("keyup", function() {
            if ($(this).val().length > 0) {
              $(".showPasswordButton").show();
              $(".hidePasswordButton").hide();
            } else {
              $(".hidePasswordButton").hide();
              $(".showPasswordButton").hide();
            }
          });
          $(function() {
            $("#password").each(function(index, input) {
              var $input = $(input);
              $translate('global.cta.show').then(function(trans) {
                  $(".showMyPasswordReg").html(trans);
              })
              $(".showMyPasswordReg").click(function() {
                var change = "";
                if ($(".showMyPasswordReg").html() === 'SHOW' || $(".showMyPasswordReg").html() === 'VOIR') {
                  $translate('global.cta.hide').then(function(trans) {
                      $(".showMyPasswordReg").html(trans);
                      $(".hidePasswordButton").show();
                      $(".showPasswordButton").hide();
                   })
                  change = "text";
                } else {
                  $translate('global.cta.show').then(function(trans) {
                      $(".showMyPasswordReg").html(trans);
                      $(".hidePasswordButton").hide();
                      $(".showPasswordButton").show();
                  });
                  change = "password";
                }
                  $input.attr('type', change);
              });
                $input.focus(function() {
                  $translate('global.cta.show').then(function(trans) {
                      $(".showMyPasswordReg").html(trans);
                  });
              });
            });
          });

          //Show Confirm password:
          $("#confirmPassword").on("keyup", function() {
            if ($(this).val().length > 0) {
              $(".showConfirmPasswordButton").show();
              $(".hideConfirmPasswordButton").hide();
            } else {
              $(".hideConfirmPasswordButton").hide();
              $(".showConfirmPasswordButton").hide();
            }
          });
          $(function() {
            $("#confirmPassword").each(function(index, input) {
              var $input = $(input);
              $translate('global.cta.show').then(function(trans) {
                  $(".showConfirmMyPasswordReg").html(trans);
              })
              $(".showConfirmMyPasswordReg").click(function() {
                var change = "";
                if ($(".showConfirmMyPasswordReg").html() === 'SHOW' || $(".showMyPasswordReg").html() === 'VOIR') {
                  $translate('global.cta.hide').then(function(trans) {
                      $(".showConfirmMyPasswordReg").html(trans);
                      $(".hideConfirmPasswordButton").show();
                      $(".showConfirmPasswordButton").hide();
                   })
                  change = "text";
                } else {
                  $translate('global.cta.show').then(function(trans) {
                      $(".showConfirmMyPasswordReg").html(trans);
                      $(".hideConfirmPasswordButton").hide();
                      $(".showConfirmPasswordButton").show();
                  });
                  change = "password";
                }
                  $input.attr('type', change);
              });
                $input.focus(function() {
                  $translate('global.cta.show').then(function(trans) {
                      $(".showConfirmMyPasswordReg").html(trans);
                  });
              });
            });
          });
        }, 10);
        }
        //FUSS-2242 : Show password functionality - end

      $scope.cancel = function(triggerClose) {
        $modalInstance.close($scope.popupLogin);
        $scope.triggerClose = triggerClose;
        window.location.href = env.fidoHomePageUrl;

        /* var myNewUrl='/'
         $location.url(myNewUrl);
         $location.replace();
         $window.history.pushState(null, 'any', $location.absUrl());*/
      };

      $modalInstance.result.finally(function() {

        // enable this section to sanitize URL
        /*  console.info('in timeout');
          window.tempvar=$location;
          var myNewUrl='/'
          $location.url(myNewUrl);
          $location.replace();
          $window.history.pushState(null, 'any', $location.absUrl());*/

        /* clean up has happend do some stuff here
         pop other window */
        if ($scope.popupLogin == true || $scope.triggerClose == 'noErrorSuccessLogin') {
          if ($scope.triggerClose == 'noErrorSuccessLogin') {
            janrainService.renderLogin();
          } else if ($scope.popupLoginErrorType == 'error') {
            dtmService.setVar(dtmServiceConstants.dtmRules.resetPassword.eVar, dtmServerSideError);
            dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.errorRule);
            janrainService.renderLogin();
            // janrain.capture.ui.modal.open('signIn');
            // janrainService.showErrorMessage(messageHtml);
          } else if ($scope.popupLoginErrorType == 'success') {

            //janrainService.setSuccessErrorMessage(true);
            $translate('global.message.passwordResetSuccess')
              .then(function(translatedValue) {
                dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.completeRule);
                // janrainService.setJanrainMessage(translatedValue);
                if(angular.isDefined($scope.userName) && !_.isEmpty($scope.userName)){
                  $window.localStorage.setItem("resetPasswordSuccessValue", "true");
                  $window.localStorage.setItem("restPasswordUserID", $scope.userName);
                }
                janrainService.renderLogin();
              });
          }
        }
      });


      /* user param */
      $http({
        method: 'POST',
        url: uteEndpoint('v1/validateURL'),
        data: $.param({
          code: $scope.validationUrl,
          screenToRender: 'passwordReset'
        }),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        } //set the headers so angular passing info as form data (not request payload)

      }).success(function(data, status, headers, config) {

        if (!data.error) {
          if (data.isExpired == true) {
            $scope.loading = false;
            $scope.selectedscreen = 'linkExpired';
            $translate('global.message.expiredLink').then(function(translatedValue) {
              var serverError = 'SS| ' + translatedValue;
              dtmService.setVar(dtmServiceConstants.dtmRules.resetPassword.eVar, serverError);
              dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.errorRule);
            });
          } else if (data.isMigrated == true) {
            /*display sign in migrated message*/
            $translate('global.error.inline.username.forgotten')
              .then(function(translatedValue) {
                $scope.popupClosewithMessage(translatedValue, 'error');
              });

          } else if (data.isDisabled == true) {
            /*display fraud message */
            $translate('global.error.inline.account.locked')
              .then(function(translatedValue) {
                $scope.popupClosewithMessage(translatedValue, 'error');
              });

          } else if (data.isQASet == false) {
            $scope.loading = false;

            $scope.selectedscreen = 'setPassword';
            dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'autoReg.setPasswordModal'}); // Tracking modal on load
            $scope.showPass();
            $scope.uuid = data.uuid;
            dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.startRule);
          } else if (data.isQASet == true) {
            $scope.loading = false;
            $scope.selectedscreen = 'setPassword';
            dataLayerService.track({}, false, [0, 1, 4], {mappingKey: 'autoReg.setPasswordModal'}); // Tracking modal on load
            $scope.showPass();
            /*$scope.securityQuestion = data.securityQuestion;

                     if (window.__userPref.language == 'fr') {
                         console.info(janrainService.SecurityQA[data.securityQuestion]);
                         var securityQAfr=janrainService.SecurityQA[data.securityQuestion];

                        if(securityQAfr!==undefined)
                        {
                          $scope.securityQuestion = securityQAfr;
                        }

                     }
            */
            $scope.uuid = data.uuid;
            dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.startRule);
          }
          //end session here if error from the server.
        } else {
          //do error condition here
          $scope.loading = false;
          $scope.selectedscreen = 'errorServerSideValidation';
          $translate('global.error.inline.link.cannotValidate').then(function(translatedValue) {
            var serverSideError = 'SS|' + translatedValue;
            dtmService.setVar(dtmServiceConstants.dtmRules.resetPassword.eVar, serverSideError);
            dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.errorRule);
          });
        }
      }).error(function(data, status, headers, config) {
        $scope.loading = false;
        $scope.selectedscreen = 'errorServerSideValidation';
        $translate('global.error.inline.link.cannotValidate').then(function(translatedValue) {
          var serverSideError = 'SS|' + translatedValue;
          dtmService.setVar(dtmServiceConstants.dtmRules.resetPassword.eVar, serverSideError);
          dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.errorRule);
        });
      });

      /* password reset form here */

      $scope.passwordRestSuccess = false;
      $scope.completedLinkexpiredForm = function(formName) {
        $scope.formError = '';
        if (!util.validateFormOnSubmit(formName)) {
          if(typeof formName.username.$modelValue == 'undefined' || formName.username.$modelValue == '') {
            $translate('global.error.inline.username.required').then(function (translatedValue) {
              dtmService.exception(dtmServiceConstants.dtmRules.forgotPassword.name, 'CS|' + translatedValue);
            });
          }
          return false;
        }

        if ((formName.username.$modelValue || '') !== '') {
          dtmService.start(dtmServiceConstants.dtmRules.forgotPassword.name);
          $http({
              method: 'POST',
              url: uteEndpoint('v1/expiredLink'),
              data: $.param({
                userName: formName.username.$modelValue,
                screenToRender: 'passwordReset',
                emailAddress: formName.username.$modelValue,
                language: $scope.lang
              }),
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }

            }).success(function(data, status, headers, config) {

              if (!(data.error || data.status == 'Failure')) {
                $scope.linkExpiredEmail = formName.username.$modelValue;
                $scope.selectedscreen = 'setLinkExpiredSubmitSuccess';
                dtmService.complete(dtmServiceConstants.dtmRules.forgotPassword.name);
                setTimeout(function() {
                $('#passwordResetEmailAlt').html($scope.linkExpiredEmail);
                },10);
              } else {
                $scope.emailPwdLinkSend.error = 'success-linkexpired-alreadysent';
                $translate('global.error.inline.link.problemSendingResetPassword').then(function(translatedValue) {
                  dtmService.exception(dtmServiceConstants.dtmRules.forgotPassword.name, 'SS|' + translatedValue);
                });
              }
              //end session here if error from the server.
            })
            .error(function(data) {
              $scope.formError = 'expiredLink';
              dtmService.exception(dtmServiceConstants.dtmRules.forgotPassword.name, 'SS|' + dtmServiceConstants.dtmRules.forgotPassword.defaultServerError);
            });
        }
      };


      $scope.setNewPassword = function(formName) {


        if (!util.validateFormOnSubmit(formName)) {
          var errorKeys = [];
          if (formName.password.$error.required || formName.confirmPassword.$error.required) {
             errorKeys.push('global.error.inline.password.required');
          }
          if (formName.password.$error.pattern || formName.confirmPassword.$error.pattern || formName.password.$error.minlength || formName.confirmPassword.$error.minlength) {
            errorKeys.push('global.message.registrationPasswordCriteria');
          }
          if((!formName.password.$error.required || !formName.confirmPassword.$error.required)
            && formName.confirmPassword.$error.passwordMismatch && (!formName.confirmPassword.$error.required && typeof formName.confirmPassword.$error.pattern == 'undefined')){
            errorKeys.push('global.error.inline.password.nonMatching');
          }
          if (errorKeys.length > 0) {
            $translate(errorKeys).then(function (translatedValues) {
              var values = [];
              angular.forEach(errorKeys, function (value) {
                values.push(translatedValues[value]);
              });
              var clientSideError = 'CS|' + values;
              dtmService.setVar(dtmServiceConstants.dtmRules.resetPassword.eVar, clientSideError);
              dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.errorRule);
            });
          }
          return false;
        }

        $http({
            method: 'POST',
            url: uteEndpoint('v1/setPRNewPassword'),
            data: $.param({
              uuid: $scope.uuid,
              password: formName.password.$modelValue,
              code: $scope.validationUrl,
            }),
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }

          })
          .success(function(data) {

            if (!data.error) {
              //$scope.passwordRestSuccess = true;
              $translate('global.error.inline.account.locked')
                .then(function(translatedValue) {
                  $scope.userName = data.userId;
                  $scope.popupClosewithMessage(translatedValue, 'success');
                });
            }

          })
          .error(function(data) {
            console.log(data);
            //alert('server error');
            //
            //popupClosewithMessage(errorDisabledAccount.$$state.value, 'success');
            dtmService.setVar(dtmServiceConstants.dtmRules.resetPassword.eVar, dtmServerSideError);
            dtmService.direct(dtmServiceConstants.dtmRules.resetPassword.errorRule);
          });

      };


      /* password reset form here */


      /* verify answer form here */

      /* FUSS-1558 : Remove Security Q/A */

      /*$scope.verifyAnswerSuccess = false;
        $scope.verifyAnswerError = false;

      $scope.checkAnswer = function(formname) {
          $scope.verifyAnswerSuccess = false;
          $scope.verifyAnswerError = false;

          if (!formname.$valid)
              return;

          $http({
                  method: 'POST',
                  url: uteEndpoint('v1/verifyPRSecretQuestionAnswer'),
                  data: $.param({
                      uuid: $scope.uuid,
                      secretAnswer: $scope.verifyAnswer.securityAnswer,
                      code: $scope.validationUrl
                  }),
                  headers: {
                      'Content-Type': 'application/x-www-form-urlencoded'
                  }

              })
              .success(function(data) {
                  if (data && !data.error && data.isValid == true) {
                      $scope.selectedscreen = 'setPassword';
                      $scope.passwordRestSuccess = false;
                  } else {
                      $scope.verifyAnswerSuccess = true;
                      $scope.verifyAnswerError = false;
                  }
              })
              .error(function(data) {
                  $scope.verifyAnswerSuccess = false;
                  $scope.verifyAnswerError = true;
              });
      };

      $scope.verifyAnswer = {};

      $scope.verifyAnswerRule = {
          securityAnswer: {
              type: 'text',
              required: true
          },

      };*/
      /* verify answer form here */
    }]);

  /* validation ends here for other 2 forms */

})();
